<template>
  <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-app-bar dark fixed color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Service Plan Assign</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mr-3" elevation="1" color="success" @click.prevent="saveFeePlan()">
            Save
          </v-btn>
        </v-app-bar>
        <v-sheet class="overflow-y-auto mt-16" max-height="600">
          <v-container fluid style="height: 1000px;">
            <v-row v-if="studentInfo">
              <v-col cols="12" md="2" sm="4">
                <v-img :src="tots_image" width="120"></v-img>
              </v-col>
              <v-col cols="12" v-if="studentInfo.enquiryCode" sm="6" md="4" lg="2">
                <div class="grey--text text-subtitle-2 mb-1">
                  Enquiry Code
                </div>
                <div class=" mb-1 " v-text="studentInfo.enquiryCode"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Name
                </div>
                <div class=" mb-1">
                  {{ studentInfo.studentFirstName ? studentInfo.studentFirstName : ' ' }} {{ studentInfo.studentLastName ? studentInfo.studentLastName : ' ' }}
                  {{ studentInfo.studentName ? studentInfo.studentName : ' ' }}
                </div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.franchisee">
                <div class="grey--text text-subtitle-2 mb-1">
                  Franchisee Name
                </div>
                <div class=" mb-1" v-text="studentInfo.franchisee.companyName || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.academicYear">
                <div class="grey--text text-subtitle-2 mb-1">
                  Academic Year
                </div>
                <div class=" mb-1" v-text="studentInfo.academicYear.academicYear || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.studentClass">
                <div class="grey--text text-subtitle-2 mb-1">
                  Class
                </div>
                <div class=" mb-1" v-text="studentInfo.studentClass.name || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherName">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Name
                </div>
                <div class="mb-1" v-text="studentInfo.fatherName"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.fatherMobile">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Mobile
                </div>
                <div class="mb-1" v-text="studentInfo.fatherMobile || ''"></div>
              </v-col>
              <v-col cols="12" md="4" v-if="studentInfo.fatherEmailID">
                <div class="grey--text text-subtitle-2 mb-1">
                  Parent / Guardian Email
                </div>
                <div class="mb-1" v-text="studentInfo.fatherEmailID || ''"></div>
              </v-col>
              <v-col cols="12" md="2" sm="4" v-if="studentInfo.gender">
                <div class="grey--text text-subtitle-2 mb-1">
                  Student Gender
                </div>
                <!-- <div class="mb-1" v-text="studentInfo.gender || ''"></div> -->
                <div v-if="studentInfo.gender ==='Female' || studentInfo.gender ==='FEMALE'" class="mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Female' ? 'Girl' : '-'||studentInfo && studentInfo.gender && studentInfo.gender ==='FEMALE' ? 'Girl' : '-'"></div>
                <div v-if="studentInfo.gender ==='Male' || studentInfo.gender ==='MALE'" class="mb-1" v-text="studentInfo && studentInfo.gender && studentInfo.gender ==='Male' ? 'Boy' : '-' || studentInfo && studentInfo.gender && studentInfo.gender ==='MALE' ? 'Boy' : '-'"></div>
                <div v-if="studentInfo.gender === null" class="mb-1">--</div>
              </v-col>
              <v-col cols="12" v-if="studentInfo.section" sm="6" md="4" lg="2">
                <div class="grey--text text-subtitle-2 mb-1">
                  Section / Division
                </div>
                <div class="mb-1" v-text="studentInfo.section ? studentInfo.section : 'N/A'"></div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card class="px-2" flat>
              <v-row>
                <v-col cols="12" md="6">
                  <span class="body-2 font-weight-medium"> Select Service <span class="error--text">*</span> </span>
                  <v-select
                    class="my-0 py-1"
                    @change="getFeePlans"
                    :items="servicesList"
                    key="id"
                    disabled
                    item-value="id"
                    item-text="name"
                    placeholder="--Select--"
                    name="serviceSelect"
                    v-model="serviceID"
                    :rules="serviceRule"
                    required
                  >
                  </v-select>
                </v-col>

                <v-col cols="12" md="6">
                  <span class="body-2 font-weight-medium"> Select Fee Plan <span class="error--text">*</span> </span>
                  <v-select
                    class="my-0 py-1"
                    @change="getTableList"
                    :items="feePlanList"
                    key="id"
                    disabled
                    item-value="id"
                    item-text="name"
                    placeholder="--Select--"
                    name="feePlanSelect"
                    v-model="planID"
                    :rules="feePlanRule"
                    required
                  >
                  </v-select>
                </v-col>
                 <!-- <v-col cols="12" md="2">
                  <span class="body-2 font-weight-medium"> Do you want to Admitted ? </span>
                  <v-switch v-model="isAdmitted" :label="isAdmitted ? 'Yes' : 'No'" color="indigo" hide-details></v-switch>
                </v-col> -->
                <!-- <v-col cols="12" md="6" lg="4">
                  <span class="body-2 font-weight-medium"> Do you want to assign Orders ? <span class="error--text">*</span> </span>
                  <v-switch v-model="isAssignOrder" :label="isAssignOrder ? 'Yes' : 'No'" color="indigo" hide-details></v-switch>
                </v-col> -->
                 <v-col cols="12" md="6" lg="4">
                <label class="font-weight-medium body-2">From </label>
                <custom-date-picker :minToDate="maxToDate" v-model="filter.fromDate" required />
              </v-col>
              <v-col cols="12" md="6" lg="4">
                <label class="font-weight-medium body-2">To </label>
                <custom-date-picker :minToDate="filter.fromDate" v-model="filter.toDate" required />
              </v-col>
                <v-col cols="12" v-if="tableInfo.length > 0">
                  <v-card-component>
                    <v-row>
                      <v-col cols="12" md="6">
                        <span class="body-3 font-weight-medium"> Choose type to apply on concession </span>
                        <v-radio-group v-model="radio">
                          <v-radio label="Percentage" value="Percentage"></v-radio>
                          <v-radio label="Amount" value="Amount"></v-radio>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" md="6">
                        <span class="body-3 font-weight-medium"> Choose Concession Order <span class="error--text">*</span> </span>
                        <v-autocomplete placeholder="--Select--" class="my-0 py-1" name="classSelect" v-model="selectedOrder" required item-value="value" :items="consessionOrder" item-text="value">
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-data-table
                      @toggle-select-all="selectAll"
                      v-model="checkedRows"
                      :single-select="singleSelect"
                      show-select
                      :headers="headers"
                      :items="tableInfo"
                      hide-default-footer
                      class="elevation-1"
                      item-key="id"
                      @item-selected="rowsReset"
                    >
                      <template v-slot:top>
                        <v-toolbar flat color="warning lighten-3" class="d-flex justify-center">
                          <v-toolbar-title>Fee Structure</v-toolbar-title>
                        </v-toolbar>
                      </template>
                      <template v-slot:item.concessionRemark="{ item }">
                        <v-autocomplete
                          required
                          :disabled="!item.isCompulsory"
                          key="id"
                          v-model="item.selectedConcessionRemark"
                          menu-props="auto"
                          label="-- Remark--"
                          single-line
                          :items="item.concessionRemark"
                          item-text="name"
                          item-value="name"
                          @input="getDisabled(item)"
                        >
                        </v-autocomplete>
                      </template>
                      <template v-slot:item.manualConcAmountPer="{ item }">
                        <input
                          required
                          class="input"
                          :disabled="item.isDropdown"
                          maxLength="100"
                          :max="100"
                          :min="0"
                          :max-height="600"
                          @input="exceptEValidation($event, item)"
                          type="number"
                          v-model="item.manualConcAmountPer"
                        />
                      </template>
                      <template v-slot:body.append>
                        <tr>
                          <th class="text-center text-subtitle-2" colspan="2">Totals</th>
                          <th class="text-center text-subtitle-2"><span class="mdi mdi-currency-inr"></span>{{ totalAmount.toFixed(2) }}</th>
                          <th class="text-center text-subtitle-2"></th>
                          <th class="text-center text-subtitle-2" v-if="radio !== 'Amount'"></th>
                          <th class="text-center text-subtitle-2" v-if="radio === 'Amount'"><span class="mdi mdi-currency-inr"></span>{{ totalConcessionAmount.toFixed(2) }}</th>
                          <th class="text-center text-subtitle-2" v-if="radio === 'Percentage'"><span class="mdi mdi-currency-inr"></span>{{ totalAmountWithConcession.toFixed(2) }}</th>
                          <th class="text-center text-subtitle-2"><span class="mdi mdi-currency-inr"></span>{{ totalAmountAfterConcession.toFixed(2) }}</th>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-component>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-sheet>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
// import CustomDatePicker from '@/components/template/CustomDatePicker'
import _ from 'lodash'
import store from '@/store'
import VCardComponent from '@/components/template/VCardComponent.vue'
import CustomDatePicker from '@/components/template/CustomDatePicker'
export default {
  name: 'ServicePlan',
  components: { VCardComponent, CustomDatePicker },
  props: ['enquiryID', 'franchiseeID', 'academicYearID', 'startDate', 'endDate', 'serviceProp', 'feePlanProp'],
  data () {
    return {
      totalAmountWithConcession: 0,
      totalAmountAfterConcession: 0,
      totalAmount: 0,
      totalConcessionAmount: 0,
      headers: this.getHeaders(),
      singleSelect: false,
      selectedOrder: 'Descending',
      consessionOrder: [
        { id: 1, value: 'Ascending' },
        { id: 2, value: 'Descending' },
        { id: 2, value: 'Equal' }
      ],
      radio: 'Percentage',
      isAssignOrder: true,
      // isAdmitted: false,
      tots_image: `${constants.RAZORPAY.TOTS_IMAGE}`,
      studentInfo: {},
      dialog: true,
      paginated: false,
      valid: true,
      feePlanList: [],
      perPage: 10,
      loadingComponent: null,
      isCustom: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      planID: '',
      info: {},
      response: [],
      orderID: '',
      isConcession: false,
      concessionInfo: [],
      serviceCategoryID: '',
      concessionID: '',
      conAdjsuType: '',
      manualConcAmount: '',
      serviceID: '',
      installmentInfo: [],
      tableInfo: [],
      checkedRows: [],
      // isAssignOrder: true,
      servicesList: [],
      feePlanRule: [v => !!v || ' Fee Plan is required'],
      serviceRule: [v => !!v || ' Service is required'],
      filter: {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      }
    }
  },
  watch: {
    planID: function (value) {
      if (_.isEmpty(value)) {
        this.concessionID = ''
        this.conAdjsuType = ''
      }
    },
    concessionID: function (value) {
      if (value === '') {
        this.concessionID = ''
        this.conAdjsuType = ''
      }
    },
    checkedRows: function (values) {
      this.calculatePayAmount()
    },
    academicYearID: async function () {
      if (this.academicYearID && this.categoryID) {
        await this.getServices()
      } else {
        this.servicesList = []
      }
    },
    categoryID: async function () {
      if (this.academicYearID && this.categoryID) {
        await this.getServices()
      } else {
        this.servicesList = []
      }
    },
    radio: function (val) {
      this.getTableList()
    },
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
    }
  },
  mounted: async function () {
    this.serviceID = this.serviceProp
    if (this.serviceID) {
      await this.getFeePlans()
    }
    this.planID = this.feePlanProp
    if (this.planID) {
      this.getTableList()
    }

    // if (this.franchisee.id) {
    //   await this.onFranchiseeChange()
    // }
  },
  async created () {
    await this.getAllInfo()
    await this.getServices()
    this.categoryID = ''
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    }),
    categoryID: {
      get () {
        return store.state.feeComponent.categoryID
      },
      set (value) {
        store.commit('updatecategoryID', value)
      }
    }
  },
  methods: {
    selectAll (event) {
      if (event.value) {
        _.map(event.items, obj => {
          obj.isCompulsory = !obj.isCompulsory || true
          obj.isDropdown = true
          obj.manualConcAmount = 0
          obj.manualConcAmountPer = 0
          obj.selectedConcessionRemark = ''
          obj.totalAmountAfterConcession = obj.amount
        })
      } else {
        _.map(event.items, obj => {
          obj.isCompulsory = !obj.isCompulsory || false
          obj.isDropdown = true
          obj.manualConcAmount = 0
          obj.manualConcAmountPer = 0
          obj.totalAmountWithConcession = 0
          obj.selectedConcessionRemark = ''
          obj.totalAmountAfterConcession = 0
        })
      }
    },
    calculatePayAmount () {
      this.totalAmount = 0
      this.totalConcessionAmount = 0
      this.totalAmountWithConcession = 0
      this.totalAmountAfterConcession = 0
      _.forEach(this.checkedRows, item => {
        this.totalAmount = this.addTwoNumber(this.totalAmount, item.amount)
        this.totalConcessionAmount = this.addTwoNumber(this.totalConcessionAmount, Number(item.manualConcAmountPer))
        this.totalAmountWithConcession = this.addTwoNumber(this.totalAmountWithConcession, Number(item.manualConcAmount))
        this.totalAmountAfterConcession = this.addTwoNumber(this.totalAmountAfterConcession, Number(item.totalAmountAfterConcession))
      })
    },
    toFixed (number, length = 2) {
      return Number(Number(number).toFixed(length))
    },
    addTwoNumber (num1, num2) {
      return this.toFixed(Number(num1) + Number(num2))
    },
    saveFeePlan: async function () {
      try {
        if (!this.planID) {
          return this.$dialog.error({
            text: ` Select Plan`,
            title: 'Error'
          })
        }
        let formData = {
          feeComponentID: this.planID,
          //  isAssignOrder: this.isAssignOrder ? this.isAssignOrder : 'false',
          academicYearID: this.academicYearID,
          serviceTypeID: this.serviceID,
          enquiryID: this.enquiryID,
          startDate: this.filter.fromDate,
          endDate: this.filter.toDate,
          // isAdmitted: this.isAdmitted ? this.isAdmitted : 'false',
          isActive: true,

          feeType: _.map(this.checkedRows, item => {
            let obj = {
              id: item.id,
              feeConcessionID: item.concessionID,
              concessionOrder: this.selectedOrder,
              concessionAmount: item.manualConcAmount
            }
            if (item.selectedConcessionRemark) {
              obj.concessionRemark = item.selectedConcessionRemark
            }
            return obj
          })
        }

        if (this.concessionID) {
          formData.feeConcessionID = this.concessionID
        }
        await http.post(`${constants.API_URL}/api/student/service/fee-plan`, formData)
        this.dialog = false
        this.okMsg('Assigned Successfully')
        this.$router.push({ name: 'serviceEnquiries' })
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        this.errMsg(errorMessage)
      }
    },
    exceptEValidation: function (event, item) {
      let amountPer = Number(event.target.value)
      if (this.radio === 'Percentage') {
        if (amountPer < 0) {
          amountPer = 0
        } else if (amountPer > 100) {
          amountPer = 100
        }
        item.manualConcAmountPer = amountPer
        item.manualConcAmount = ((item.amount * amountPer) / 100).toFixed(2)
        item.totalAmountAfterConcession = item.amount - ((item.amount * amountPer) / 100).toFixed(2)
      } else {
        if (item.amount > amountPer) {
          item.manualConcAmountPer = amountPer
          item.manualConcAmount = item.manualConcAmountPer
          item.totalAmountAfterConcession = (item.amount - amountPer).toFixed(2)
          if (item.manualConcAmount < 0 || item.manualConcAmountPer === 0 || item.manualConcAmountPer === '') {
            item.manualConcAmountPer = 0
            item.manualConcAmount = 0
          }
        } else {
          item.manualConcAmountPer = 0
          item.manualConcAmount = 0
          item.totalAmountAfterConcession = item.amount
        }
      }
      this.calculatePayAmount()
    },
    rowsReset (value) {
      console.log('Inside Row Reset Rows---', value)
      value.item.isCompulsory = !value.item.isCompulsory
      if (!value.item.isCompulsory) {
        value.item.manualConcAmount = 0
        value.item.manualConcAmountPer = 0
        value.item.totalAmountAfterConcession = 0
        value.item.selectedConcessionRemark = ''
      } else {
        value.item.totalAmountAfterConcession = value.item.amount
      }
      value.isDropdown = !value.isDropdown
    },
    getHeaders () {
      let header = [
        { text: 'Fee Type', value: 'feeType.name', align: 'center' },
        { text: 'Amount', value: 'amount', align: 'center' },
        { text: 'Concession Remark', value: 'concessionRemark', align: 'center' }
      ]
      if (this.radio === 'Percentage') {
        header.push({ text: 'Concession %', value: 'manualConcAmountPer', align: 'center' })
        header.push({ text: 'Concession Amount', value: 'manualConcAmount', align: 'center' })
      } else {
        header.push({ text: 'Concession Amount INR', value: 'manualConcAmountPer', align: 'center' })
      }
      header.push({ text: 'Amount To pay ', value: 'totalAmountAfterConcession', align: 'center' })
      header.push({ text: '', value: 'data-table-expand' })
      return header
    },
    getDisabled: function (item) {
      const index = this.tableInfo.findIndex((ele, index) => {
        if (ele.id === item.id) {
          return true
        }
      })
      let udatedData = item
      if (item.selectedConcessionRemark) {
        udatedData.isDropdown = false
      } else {
        udatedData.isDropdown = true
        udatedData.manualConcAmount = 0
        udatedData.manualConcAmountPer = 0
      }
      udatedData.manualConcAmount = 0
      this.tableInfo.splice(index, 1, udatedData)
    },
    getTableList: async function () {
      this.checkedRows = []
      if (this.planID) {
        _.map(this.feePlanList, item => {
          if (item.id === this.planID) {
            this.tableInfo = item.feeComponentFeeTypeMaps
          }
        })
      } else {
        this.tableInfo = []
      }
      _.map(this.tableInfo, element => {
        element.concessionRemark = [
          { id: 1, name: 'Sibling Concession' },
          { id: 2, name: 'Staff Concession' },
          { id: 3, name: 'One-shot Payment Concession' },
          { id: 4, name: 'Referral Concession' },
          { id: 5, name: 'General / Other Concession' }
        ]
        element.manualConcAmount = 0
        element.manualConcAmountPer = 0
        if (element.isCompulsory) {
          element.totalAmountAfterConcession = element.amount
        } else {
          element.totalAmountAfterConcession = 0
          element.isCompulsory = false
        }
        element.selectedConcessionRemark = ''
        element.isDropdown = true
        if (element.isCompulsory === true) {
          this.checkedRows.push(element)
        }
      })
      this.headers = this.getHeaders()
      this.calculatePayAmount()
    },
    getServices: async function () {
      // if (this.isService && this.academicYearID && this.categoryID && this.franchiseeIDMutiple.length > 0) {
      try {
        let { data } = await http.get(`${constants.API_URL}/api/service/type/list/?academicYearID=${this.academicYearID}&&categoryID=${this.serviceCategoryID}&&franchiseeID=${this.franchiseeID}`)

        this.servicesList = data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
      }
      // }
    },
    getFeePlans: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/service/plan?franchiseeID=${this.franchiseeID}&&academicYearID=${this.academicYearID}&&serviceTypeID=${this.serviceID}`)
        this.feePlanList = res.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getAllInfo: async function () {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        let { data } = await http.get(`${constants.API_URL}/api/student/service/fee-plan`, {
          params: {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYearID,
            isRequired: false,
            enquiryID: this.enquiryID,
            startDate: this.startDate,
            endDate: this.endDate
          }
        })
        console.log(data, 'Mydata')
        this.studentInfo = data[0]
        this.loadingComponent.close()
      } catch (e) {
        this.loadingComponent.close()
        this.dialog = false
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        console.log('error in fetching data : ', errorMessage)
        return this.$dialog.error({
          text: ` ${errorMessage}`,
          title: 'Error'
        })
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }

        this.inProgress = false
      }
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    }
  }
}
</script>
